export interface BuyerCardStatusSummary {
	total: number
	active: number
	blocked: number
	frozen: number
	closed: number
	unavailable: number
}

export interface UserBlockProgressSummary {
	total: number
	pending: number
	completed: number
	failed: number
	skipped: number
	processed: number
}

export const summarizeBuyerCards = (
	cards: ReadonlyArray<Pick<ICardSaved, "status">>
): BuyerCardStatusSummary => {
	let active = 0
	let blocked = 0
	let frozen = 0
	let closed = 0
	let unavailable = 0
	const unavailableStatuses = new Set([
		"blocked",
		"frozen",
		"closed",
		"lost",
		"replaced",
		"unavailable",
		"declined",
		"error"
	])

	for (const card of cards) {
		if (card.status === "active") active += 1
		if (card.status === "blocked") blocked += 1
		if (card.status === "frozen") frozen += 1
		if (card.status === "closed") closed += 1
		if (unavailableStatuses.has(card.status)) unavailable += 1
	}

	return {
		total: cards.length,
		active,
		blocked,
		frozen,
		closed,
		unavailable
	}
}

export const summarizeUserBlockProgress = (
	cards: ReadonlyArray<Pick<IUserBlockCardStatus, "status">>
): UserBlockProgressSummary => {
	let pending = 0
	let completed = 0
	let failed = 0
	let skipped = 0

	for (const card of cards) {
		if (card.status === "pending") pending += 1
		if (card.status === "completed") completed += 1
		if (card.status === "failed") failed += 1
		if (card.status === "skipped") skipped += 1
	}

	return {
		total: cards.length,
		pending,
		completed,
		failed,
		skipped,
		processed: completed + failed + skipped
	}
}

export const getUserBlockProgressMessage = (
	mode: "freeze" | "block",
	progress: UserBlockProgressSummary
) => {
	const action = mode === "freeze" ? "Freezing" : "Closing"
	if (progress.total === 0) return `${action} cards. Waiting for the operation list...`

	return `${action} cards: ${progress.processed} of ${progress.total} processed.`
}
